<template>
  <section>
    <elNavbar />
    <!-- Start Banner Hero -->
    <section class="bg-light">
      <div class="container py-4">
        <div class="row align-items-center justify-content-between">
          <div class="contact-header col-12 col-md-7">
            <h1 class="h2 pb-3 text-primary">Contact us</h1>
            <p class="light-300">
              Do you have any question or comment about the App?
              <br />Do you face any issue using the App?
              <br />
              <br />Then, do not hesitate to contact us; we will be happy to
              hear from you! <br />You can send an email with your query using
              the following form, or write to
              <a href="mailto:info@newabc.eu" class="" title="Send us Email"
                >info@newabc.eu</a
              >
            </p>
          </div>
          <div class="contact-img col-12 col-md-5">
            <img
              :src="
                $store.state.config.frontpoint + '/storage/Contact-us-pana.png'
              "
              class="img-fluid"
            />
          </div>
        </div>
      </div>
    </section>
    <!-- End Banner Hero -->

    <!-- Start Contact -->
    <section class="">
      <div class="container py-5">
        <h1 class="col-12 col-xl-8 h2 text-left text-primary pt-3">
          Create success campaign with us!
        </h1>
        <h2 class="col-12 col-xl-8 h4 text-left regular-400">
          Elit, sed do eiusmod tempor
        </h2>
        <p class="col-12 col-xl-8 text-left pb-3 light-300">
          Incididunt ut labore et dolore magna aliqua. Quis ipsum suspendisse
          ultrices gravida. Risus commodo viverra maecenas accumsan lacus vel
          facilisis. Laboris nisi ut aliquip ex ea commodo consequat. Duis aute
          irure dolor in reprehenderit in voluptate.
        </p>

        <div class="col-12 col-md-8">
          <form
            class="contact-form row text-primary"
            method="post"
            action="#"
            role="form"
          >
            <div class="col-lg-6 mb-4">
              <div class="form-floating">
                <input
                  type="text"
                  class="form-control form-control-lg light-300"
                  id="floatingname"
                  placeholder="Name"
                  v-model="name"
                  required
                />
                <label for="floatingname light-300">Name</label>
              </div>
            </div>
            <!-- End Input Name -->

            <div class="col-lg-6 mb-4">
              <div class="form-floating">
                <input
                  type="email"
                  class="form-control form-control-lg light-300"
                  id="floatingemail"
                  placeholder="Email"
                  v-model="email"
                  required
                />
                <label for="floatingemail light-300">Email</label>
              </div>
            </div>
            <!-- End Input Email -->

            <div class="col-lg-6 mb-4">
              <div class="form-floating">
                <input
                  type="tel"
                  class="form-control form-control-lg light-300"
                  id="floatingphone"
                  placeholder="Phone"
                  v-model="phone"
                />
                <label for="floatingphone light-300">Phone</label>
              </div>
            </div>
            <!-- End Input Phone -->

            <div class="col-lg-6">
              <div class="form-floating mb-3">
                <input
                  type="text"
                  class="form-control form-control-lg light-300"
                  id="floatingsubject"
                  placeholder="Subject"
                  v-model="subject"
                />
                <label for="floatingsubject light-300">Subject</label>
              </div>
            </div>
            <!-- End Input Company Name -->

            <div class="col-12">
              <div class="form-floating mb-3">
                <textarea
                  class="form-control light-300"
                  rows="8"
                  placeholder="Message"
                  v-model="message"
                  id="floatingtextarea"
                ></textarea>
                <label for="floatingtextarea light-300">Message</label>
              </div>
            </div>
            <!-- End Textarea Message -->

            <div class="col-md-12 col-12 m-auto text-end">
              <button
                @click="sent"
                type="submit"
                class="btn btn-primary light-300"
              >
                Send Message
              </button>
            </div>
          </form>
        </div>
        <!-- End Contact Form -->
      </div>
    </section>
    <!-- End Contact -->
    <elFooter />
  </section>
</template>

<script>
import elFooter from "../components/Footer.vue";
import elNavbar from "../components/Navbar.vue";

export default {
  name: "Contact",
  metaInfo: {
    title: "Contact",
    titleTemplate: "%s | NEW ABC APP",
  },
  components: {
    elFooter,
    elNavbar,
  },

  data() {
    return {
      name: "",
      email: "",
      phone: "",
      subject: "",
      message: "",
      nameIsCorrect: false,
      emailIsCorrect: false,
    };
  },
  mounted() {
    this.$nextTick(() => {});
  },

  watch: {
    name() {
      const val = this.$store.state.utils.filters.fullname(this.name);
      this.nameIsCorrect = val.has_minimum_lenth && val.only_letters;
    },

    email() {
      const val = this.$store.state.utils.filters.validateEmail(this.email);
      this.emailIsCorrect = val;
    },
  },

  methods: {
    sent() {
      event.preventDefault();
      if (this.nameIsCorrect && this.emailIsCorrect) {
        const data = {
          name: this.name,
          email: this.email,
          phone: this.phone,
          subject: this.subject,
          message: this.message,
        };

        this.$store.state.api.sentMessage(data).then((resp) => {
          this.name = "";
          this.email = "";
          this.phone = "";
          this.subject = "";
          this.message = "";
          if (resp.status == 200) {
            this.$store.state.utils.setNewNotifications(
              {
                type: "warning",
                message: "thank your ",
              },
              2500
            );
          } else {
            this.$store.state.utils.setNewNotifications(
              {
                type: "warning",
                message: "Check the entries are correct",
              },
              2500
            );
          }
        });
      } else {
        this.$store.state.utils.setNewNotifications(
          {
            type: "warning",
            message: "Check the entries are correct",
          },
          2500
        );
      }
    },
  },
};
</script>
